import FormItemDetail from './components/formItemDetail'
import MixinInput from './components/mixinInput'
import DateCombination from './components/dateCombination'
// import AnsoTreeSelect from '../components/anso-tree-select'
import { removeAriaHidden } from '../directives'
// import AnsoTableEdit from '../components/anso-table-edit'
import DataRange from './components/dataRange'
import MultipleTime from './components/multipleTime'
// import ansoUpload from '../components/anso-upload'
export default {
  components: {
    FormItemDetail,
    MixinInput,
    // AnsoTreeSelect,
    DateCombination,
    // AnsoTableEdit,
    DataRange,
    MultipleTime,
  },
  directives: {
    // 移除自定义radio的aria-hidden属性
    removeAriaHidden,
  },
  methods: {
    generateFormItemChild(item, form) {
      let { type, label, field } = item
      let {
        props,
        placeholder,
        editDisabled,
        disabled,
        options = [],
        propKeys,
        event,
        multiple,
        filterable,
        text,
        maxlength,
        slots,
        startPlaceholder,
        endPlaceholder,
        uploadData,
      } = item
      propKeys = propKeys || { label: 'label', value: 'value' }
      options = typeof options === 'function' ? options(item, form) : options
      if (this.modelType === 'edit' && editDisabled) {
        item.disabled = true
      }
      switch (type) {
        case 'select':
          return this.modelType === 'detail' ? (
            this.showDetail(item, form[field], form)
          ) : (
            <el-select
              key={field}
              v-model={form[field]}
              props={props}
              multiple={multiple}
              placeholder={placeholder || `请选择${label}`}
              disabled={disabled}
              on={{ ...event }}
              clearable
              filterable={typeof filterable === 'boolean' ? filterable : true}
            >
              {options.map((m) => {
                return (
                  <el-option
                    key={m[propKeys['value']]}
                    label={m[propKeys['label']]}
                    value={m[propKeys['value']]}
                    disabled={m.disabled || false}
                  ></el-option>
                )
              })}
            </el-select>
          )
        case 'title':
          return <div class="title">{label}</div>
        case 'subTitle':
          return <div class="subTitle">{label}</div>
        case 'divider':
          return <el-divider class="divider"></el-divider>
        case 'custom':
          return item.render(item, form, this.modelType)
        case 'button':
          return (
            <el-button
              props={props}
              onClick={() => {
                event.click()
              }}
              disabled={disabled}
            >
              {text}
            </el-button>
          )
        case 'textarea':
          return this.modelType === 'detail' ? (
            this.showDetail(item, form[field], form)
          ) : (
            <el-input
              type="textarea"
              v-model={form[field]}
              props={props}
              attrs={props}
              placeholder={placeholder || '请输入'}
              disabled={disabled}
              maxlength={maxlength}
              on={{ ...event }}
              show-word-limit
              clearable
            ></el-input>
          )
        case 'time':
        case 'timePicker':
          return this.modelType === 'detail' ? (
            this.showDetail(item, form[field], form)
          ) : (
            <el-time-picker
              v-model={form[field]}
              props={props}
              placeholder={placeholder || '请选择'}
              disabled={disabled}
              on={{ ...event }}
              clearable
              value-format="timestamp"
            ></el-time-picker>
          )
        case 'date':
        case 'week':
        case 'month':
        case 'year':
        case 'daterange':
        case 'monthrange':
        case 'datetime':
        case 'datetimerange':
          return this.modelType === 'detail' ? (
            this.showDetail(item, form[field], form)
          ) : (
            <el-date-picker
              type={type}
              key={field}
              v-model={form[field]}
              props={props}
              placeholder={placeholder || '请选择'}
              start-placeholder={startPlaceholder}
              end-placeholder={endPlaceholder}
              disabled={disabled}
              on={{ ...event }}
              clearable
              value-format="timestamp"
            ></el-date-picker>
          )
        case 'dateCombination':
          return this.modelType === 'detail' ? (
            this.showDetail(item, form[field], form)
          ) : (
            <date-combination
              clearable
              value-format="timestamp"
              v-model={form[field]}
              props={props}
              placeholder={placeholder || '请选择'}
              startPlaceholder={startPlaceholder}
              endPlaceholder={endPlaceholder}
              disabled={disabled}
              event={{ ...event }}
            ></date-combination>
          )
        case 'multipleTime':
          return this.modelType === 'detail' ? (
            this.showDetail(item, form[field], form)
          ) : (
            <multiple-time
              clearable
              v-model={form[field]}
              props={props}
              options={options}
              event={{ ...event }}
            ></multiple-time>
          )
        case 'cascader':
          return this.modelType === 'detail' ? (
            this.showDetail(item, form[field], form)
          ) : (
            <el-cascader
              v-model={form[field]}
              props={props}
              on={{ ...event }}
              options={options}
              disabled={disabled}
            ></el-cascader>
          )
        case 'switch':
          return this.modelType === 'detail' ? (
            this.showDetail(item, form[field], form)
          ) : (
            <el-switch
              v-model={form[field]}
              props={props}
              disabled={disabled}
              on={{ ...event }}
              active-color="#3171f2"
            ></el-switch>
          )
        case 'radio':
          return this.modelType === 'detail' ? (
            this.showDetail(item, form[field], form)
          ) : (
            <el-radio-group
              v-model={form[field]}
              disabled={disabled}
              props={props}
              on={{ ...event }}
              v-removeAriaHidden
            >
              {options.map((el) => {
                return (
                  <el-radio
                    disabled={el['disabled']}
                    label={el[propKeys['value']]}
                  >
                    {el[propKeys['label']]}
                  </el-radio>
                )
              })}
            </el-radio-group>
          )
        case 'checkbox':
          return this.modelType === 'detail' ? (
            this.showDetail(item, form[field], form)
          ) : (
            <el-checkbox-group
              v-model={form[field]}
              props={props}
              disabled={disabled}
              on={{ ...event }}
            >
              {options.map((el) => {
                return (
                  <el-checkbox
                    disabled={el.disabled || false}
                    label={el[propKeys['value']]}
                  >
                    {el[propKeys['label']]}
                  </el-checkbox>
                )
              })}
            </el-checkbox-group>
          )
        case 'mixinInput':
          return this.modelType === 'detail' ? (
            this.showDetail(item, form[field], form)
          ) : (
            <mixin-input
              v-model={form[field]}
              props={props}
              event={{ ...event }}
              options={options}
            ></mixin-input>
          )
        case 'descriptions':
          return (
            <anso-descriptions
              props={{ ...props }}
              isFormChildItem
              form={form}
              formField={field}
              modelType={this.modelType}
            ></anso-descriptions>
          )
        case 'table':
          return
        // case 'tableEdit':
        //   return (
        //     <anso-table-edit
        //       props={{ ...props }}
        //       isFormChildItem
        //       form={form}
        //       tableField={field || 'tableData'}
        //       modelType={this.modelType}
        //     ></anso-table-edit>
        //   )
        // case 'upload':
        //   return (
        //     <ansoUpload
        //       v-model={this.form[field]}
        //       props={props}
        //       uploadData={uploadData}
        //       modelType={this.modelType}
        //       on={{
        //         ['update:fileList']: (val) => {
        //           this.form[field] = val
        //         },
        //         ...event,
        //       }}
        //     ></ansoUpload>
        //   )
        // case 'selectTree': {
        //   return this.modelType === 'detail' ? (
        //     this.showDetail(item, form[field], form)
        //   ) : (
        //     <anso-tree-select
        //       v-model={form[field]}
        //       multiple={multiple}
        //       props={{
        //         ...props,
        //         data:
        //           typeof props.data === 'function'
        //             ? props.data(item, form)
        //             : props.data,
        //       }}
        //       on={{
        //         ...event,
        //       }}
        //     ></anso-tree-select>
        //   )
        // }
        case 'autocomplete':
          return (
            <el-autocomplete
              v-model={form[field]}
              props={props}
              fetch-suggestions={(queryString, cb) => {
                this.querySearch(queryString, cb, options, propKeys)
              }}
              placeholder={placeholder || '请输入'}
              disabled={disabled}
              maxlength={maxlength || 100}
              clearable
              on={{ ...event }}
            ></el-autocomplete>
          )
        case 'dataRange':
          return (
            <data-range
              v-model={form[field]}
              props={{ ...props, options }}
              on={{ ...event }}
            ></data-range>
          )
        case 'number':
        case 'password':
        default:
          return this.modelType === 'detail' ? (
            this.showDetail(item, form[field], form)
          ) : (
            <el-input
              type={type || 'text'}
              v-model={form[field]}
              props={props}
              placeholder={placeholder || '请输入'}
              disabled={disabled}
              maxlength={maxlength || 100}
              clearable
              on={{ ...event }}
              nativeOn={{
                keyup: (e) => {
                  event &&
                    typeof event['keyup'] === 'function' &&
                    event['keyup'](e)
                },
              }}
            >
              {(slots || []).map((m) => {
                return (
                  <template slot={m.slot}>
                    {typeof m.render === 'function' && m.render()}
                  </template>
                )
              })}
            </el-input>
          )
      }
    },
    showDetail(item, value, form) {
      let options =
        typeof item.options === 'function'
          ? item.options(item, form)
          : item.options
      return (
        <form-item-detail
          item={{ ...item, options }}
          value={value}
        ></form-item-detail>
      )
    },
    querySearch(queryString, cb, options, propKeys) {
      const result = queryString
        ? options.filter(this.createFilter(queryString, propKeys))
        : options

      console.log(result)
      cb(result)
    },
    createFilter(queryString, propKeys) {
      return (options) => {
        return options[propKeys['value']].includes(queryString)
      }
    },
  },
}
